export default __webpack_public_path__ + "static/media/ies_AcercaDe.ba373a33.png";